<template>
	<page-header-wrapper>
		<template slot="extra">
			<a-button type="primary" @click="exportExcel">导出数据</a-button>
		</template>
		<a-card :bordered="false">
			<div class="table-page-search-wrapper">
				
			</div>

			<s-table ref="table" size="default" :rowKey="(record) => record.id" :columns="columns" :data="loadData" :scroll="{x:'100%'}"
			 showPagination="auto" class="">
				<span slot="serial" slot-scope="text, record, index">
					{{ index + 1 }}
				</span>
				<span slot="minUseTime" slot-scope="minUseTime">{{minUseTime>0?minUseTime/1000:minUseTime}}s</span>
				<span slot="totalTime" slot-scope="totalTime">{{totalTime>0?totalTime/1000:totalTime}}s</span>
			</s-table>
		</a-card>
	</page-header-wrapper>
</template>

<script>
	import moment from 'moment'
	import {
		Modal,
		message
	} from 'ant-design-vue'
	import {
		STable,
		Ellipsis
	} from '@/components'
	import Clipboard from 'clipboard'
	import {
		prefix,
		getSource,
		getUrlKey
	} from '@/utils'
	import {
		getRankList
	} from '@/api/answer.js'
	const columns = [
		{
			title: '名次',
			scopedSlots: {
				customRender: 'serial'
			},
			align: 'center'
		},
		{
			title: '参与人',
			dataIndex:'nickname',
			align: 'center'
		},
		{
			title: '累计答对题数',
			dataIndex:'totalPoints',
			align: 'center'
		},
		{
			title: '累计用时',
			dataIndex:'totalTime',
			scopedSlots: {
				customRender: 'totalTime'
			},
			align: 'center'
		},
		{
			title: '最快用时',
			dataIndex:'minUseTime',
			scopedSlots: {
				customRender: 'minUseTime'
			},
			align: 'center'
		},
		{
			title: '总参与次数',
			dataIndex:'joinCount',
			align: 'center'
		}
	]

	export default {
		name: '',
		components: {
			STable,
			Ellipsis
		},
		data() {
			this.columns = columns
			return {
				// create model
				visible: false,
				advanced: false,
				// 查询参数
				queryParam: {
					keyword: '',
					tid:getUrlKey('id')
				},
				// 加载数据方法 必须为 Promise 对象
				loadData: parameter => {
					//console.log('parameter',parameter)
					const requestParameters = Object.assign({}, parameter, this.queryParam)
					//console.log('requestParameters',requestParameters)
					return getRankList(requestParameters)
						.then(res => {
							return res.data
						})
				},
				prefix: prefix,
				
			}
		},
		methods: {
			exportExcel(){
				let url = this.prefix+'/newAdmin.php?c=operate&a=exportLeaderBoard&tid='+getUrlKey('id')
				window.open(url)
			}
		},
		filters: {
			time(t) {
				if (t) {
					return moment(parseInt(t) * 1000).format('YYYY/MM/DD HH:mm:mm')
				} else {
					return t
				}
			},
			statusFilter(type) {
				return statusMap[type].text
			},
			statusTypeFilter(type) {
				return statusMap[type].status
			}
		}
	}
</script>


<style scoped>
	.tab_main {}

	.tab_main_title {
		margin-right: 10px;
	}

	.tab_main_block {
		margin-right: 10px;
		cursor: pointer;
	}

	.tab_main_act {
		color: #1890ff;
	}

	.content_line1 {
		margin-bottom: 15px;
	}

	.content_line1_title {
		font-weight: 600;
		font-size: 16px;
		color: #000;
	}

	.content_line2 {}

	.content_line2_data {}

	.content_line2_data i {
		font-style: normal;
		color: #f50;
		margin: 0 5px;
	}
</style>
